// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__llV42"};